import { useQuery } from '@tanstack/react-query';
import { getTechnicianScorecard } from '../services/TechnicianPerformanceService';
import { iimReviewKeys } from './queryKeys';
export function useTechnicianScorecard(technicianId, enabled, inspectionId) {
    return useQuery({
        queryKey: iimReviewKeys.technicianScorecard(technicianId, inspectionId),
        queryFn: () => getTechnicianScorecard(technicianId, inspectionId),
        enabled,
        staleTime: 5 * 60 * 1000
    });
}
